import { Mic, Clock, BarChart3, Settings } from "lucide-react";
import { NavLink } from "react-router-dom";

const items = [
    { to: "/home", icon: Mic, label: "Practice", testid: "nav-practice" },
    { to: "/history", icon: Clock, label: "History", testid: "nav-history" },
    { to: "/insights", icon: BarChart3, label: "Insights", testid: "nav-insights" },
    { to: "/settings", icon: Settings, label: "Settings", testid: "nav-settings" },
];

export default function BottomNav() {
    return (
        <nav
            className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 sm:gap-3 px-3 py-2 rounded-full
                bg-white/85 dark:bg-[#242322]/85 backdrop-blur-xl shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-stone-200/70 dark:border-stone-800/80"
            data-testid="bottom-nav"
        >
            {items.map(({ to, icon: Icon, label, testid }) => (
                <NavLink
                    key={to}
                    to={to}
                    end={to === "/home"}
                    data-testid={testid}
                    className={({ isActive }) =>
                        `flex flex-col items-center gap-0.5 px-3 sm:px-4 py-1.5 rounded-full transition-colors
                        ${isActive
                            ? "text-terracotta bg-terracotta/10"
                            : "text-stone-500 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-100"}`
                    }
                >
                    <Icon size={20} strokeWidth={1.5} />
                    <span className="text-[10px] tracking-[0.15em] uppercase font-medium">{label}</span>
                </NavLink>
            ))}
        </nav>
    );
}
